import { Component } from "@angular/core";
import { NavController, LoadingController } from "ionic-angular";
import { ConfirmPage } from "../confirm/confirm";
import { User } from "../../providers/user";
import { ViewController } from "ionic-angular/navigation/view-controller";
import { ModalController } from "ionic-angular/components/modal/modal-controller";

export class UserDetails {
  username: string;
  email: string;
  password: string;
  password2: string;
}

@Component({
  selector: "page-signup",
  templateUrl: "signup.html"
})
export class SignupPage {
  public userDetails: UserDetails;

  error: any;

  constructor(
    public navCtrl: NavController,
    public user: User,
    public loadingCtrl: LoadingController,
    private viewCtrl: ViewController,
    private modalCtrl: ModalController
  ) {
    this.userDetails = new UserDetails();
  }

  signup() {
    let loading = this.loadingCtrl.create({
      content: "Please wait..."
    });

    let details = this.userDetails;
    this.error = null;

    if (details.password !== details.password2) {
      this.error = new Error("Passwords do not match.");
      console.log(this.error);
      return;
    }

    loading.present();
    console.log("register");
    this.user
      .register(details.username, details.password, { email: details.email })
      .then(user => {
        loading.dismiss();
        console.log("signup success, push confirm page");
        this.viewCtrl.dismiss();
        let modal = this.modalCtrl.create(ConfirmPage, {
          username: details.username
        });
        modal.present();
      })
      .catch(err => {
        loading.dismiss();
        this.error = err;
        console.log(this.error);
      });
  }

  login() {
    this.viewCtrl.dismiss();
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts